import React from "react"

import ConditionTypeSelector from "../../../../../proto/render/condition/condition-type-selector"
import SelectMultiGenericNew from "../../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import FieldUser_MultiselectValueNotEmpty from "../../../../../generic/user/components/multiselect/value-not-empty"
import FieldUser_MultiselectPopoverOption from "../../../../../generic/user/components/multiselect/popover-option"
import {FieldConditionFormProps, FieldConditionRenderMode} from "../../../../../render/condition/@types"
import Filter from "../../../../../../manager/filters/manager/filter"
import {ConditionType} from "../../../../../../model2/conditions/condition-types"
import FieldTaskActionRequiredUser from "../action-required-user"
import {FieldConditionsDropdown_NotAssignedOption} from "../../../../../conditions/dropdown";

// const debug = "FieldTaskActionRequiredUser_ConditionForm"
const debug = false

export default function FieldTaskActionRequiredUser_ConditionForm(props:FieldConditionFormProps) {

    const filter = props.condition as Filter
    const field = filter.field as FieldTaskActionRequiredUser

    const onChangeType = (conditionType: ConditionType) => {
        props.condition.type = conditionType
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const onChangeValue = (value: any) => {
        props.condition.value = value
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const getOptions = async (): Promise<Option[]> => {
        switch (props.renderMode) {
            case FieldConditionRenderMode.FILTER_ITEMS_COLLECTION:
            case FieldConditionRenderMode.FILTER_COLLECTION:
                return await field.filterGetOptions(filter)

            case FieldConditionRenderMode.CONDITION:
            default:
                // doesn't apply
                return []
        }
    }

    console.log('!!!FieldTaskActionRequiredUser_ConditionForm render')

    return (
        <>
            <ConditionTypeSelector field    = {props.field}
                                   value    = {props.condition.type}
                                   onChange = {onChangeType}/>

            <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                   options                          = {field.filterGetAllOptions()}
                                   getPopoverOptions                = {getOptions}
                                   values                           = {props.condition.value}
                                   popoverContainerClasses          = "max-w-200"
                                   popoverScrollContainerClasses    = "max-h-200"
                                   valueComponent                   = {FieldUser_MultiselectValueNotEmpty}
                                   popoverOptionComponent           = {FieldUser_MultiselectPopoverOption}
                                   isSearchable                     = {true}
                                   onChange                         = {onChangeValue}/>
        </>
    )
}